import { type Area } from "react-easy-crop";

/**
 * Creates a cropped image from the given image and crop area
 * @param imageSrc - The source image (base64 data URL or regular URL)
 * @param cropArea - The crop area from react-easy-crop
 * @returns Promise that resolves to a base64 data URL of the cropped image
 */
export async function getCroppedImageFromArea(
  imageSource: string,
  cropArea: Area
): Promise<string> {
  return await new Promise((resolve, reject) => {
    const image = new Image();

    image.addEventListener("load", () => {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      if (!context) {
        reject(new Error("Could not get canvas context"));
        return;
      }

      // Set canvas size to crop area size
      canvas.width = cropArea.width;
      canvas.height = cropArea.height;

      // Draw the cropped portion of the image
      context.drawImage(
        image,
        cropArea.x,
        cropArea.y,
        cropArea.width,
        cropArea.height,
        0,
        0,
        cropArea.width,
        cropArea.height
      );

      // Convert canvas to base64
      const base64 = canvas.toDataURL("image/jpeg", 0.9);
      resolve(base64);
    });

    image.addEventListener("error", () => {
      reject(new Error("Failed to load image"));
    });

    image.src = imageSource;
  });
}
